/**
 * useSEO — set per-route <title>, meta description, canonical, OG + Twitter
 * tags without adding react-helmet. Called from every top-level route.
 */
import { useEffect } from "react";

const SITE = "https://capittance.com";
const DEFAULT_IMG = `${SITE}/og-cover.png`;

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  if (!href) return;
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(data) {
  let el = document.head.querySelector('script[data-seo-jsonld="1"]');
  if (!data) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-seo-jsonld", "1");
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function useSEO({ title, description, path = "", image = DEFAULT_IMG, type = "website", jsonLd = null }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    upsertJsonLd(ld ? JSON.parse(ld) : null);
    const url = `${SITE}${path}`;
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertCanonical(url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", "Capittance");
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);
  }, [title, description, path, image, type, ld]);
}
